<form (validate)="save({draft: false})" novalidate validation-es>

  <ms-consult-patient [patient]="patient" [edit]="isEdit" [(sticky)]="isSticky" (saveConsult)="save($event)">
  </ms-consult-patient>

  <article class="page-container page__consult" [attr.sticky]="isSticky ? 'sticky' : null">
    <p-tabView>
      <p-tabPanel [selected]="true">
        <ng-template pTemplate="header">
          {{screen.labels.actual}} {{today | date : 'dd-MM-yyyy' : '+0000'}}
        </ng-template>

        <ng-template pTemplate="content">
          <div class="inline-flex col-12 justify-content-center align-items-center" *ngIf="!turnId || !patientId">
            <p-progressSpinner></p-progressSpinner>
          </div>
          <ms-consult-wrapper [turn]="turnId" [patient]="patientId" *ngIf="turnId && patientId"
            [(patientData)]="patientData">
            <ms-history-personal [hasComplete]="isGyne"
              [(mainDetail)]="patientData.personalHistory"></ms-history-personal>
            <ms-history-personal-complete *ngIf="isGyne"></ms-history-personal-complete>
            <ms-history-family [hasComplete]="isGyne" [(mainDetail)]="patientData.familyHistory"></ms-history-family>
          </ms-consult-wrapper>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel *ngFor="let oldTurn of oldTurns">
        <ng-template pTemplate="header">
          {{oldTurn.turnDate | date : 'dd-MM-yyyy' : '+0000'}}
        </ng-template>

        <ng-template pTemplate="content">
          <section class="flex flex-wrap align-items-center mb-2">
            <h3 class="col-12 md:col-3 lg:col-2 consult__section-subheading">{{screen.labels.doctor}}:</h3>
            <span class="col-12 md:col-9 lg:col-4">{{oldTurn.doctorName}}</span>

            <h3 class="col-12 md:col-3 lg:col-2 consult__section-subheading">{{screen.labels.specialty}}:</h3>
            <span class="col-12 md:col-9 lg:col-4">{{oldTurn.specialtyName}}</span>
          </section>
          <ms-consult-wrapper [turn]="oldTurn.id!" [readonly]="true"></ms-consult-wrapper>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </article>

</form>